import { Component } from '@angular/core';
import { DynamicDialogComponent } from './dynamic-dialog.component';
import { DynamicDialog } from './dynamic-dialog';

@Component({
  imports: [DynamicDialogComponent],
  selector: 'ct-extraction-skip-current-document-dialog',
  template: `
    <ct-dynamic-dialog [title]="'Dokument überspringen'">
      <p>
        Sind Sie sich sicher, dass Sie die Erfassung dieses Dokuments überspringen möchten? Ggfls.
        bereits erfasste Daten gehen verloren.
      </p>
    </ct-dynamic-dialog>
  `,
})
export class SkipCurrentDocumentDialogComponent implements DynamicDialog<boolean> {}
